import { CredentialItem } from './credential-item'

export class ViolationCredentialItem extends CredentialItem {

  public constructor(data: any) {
    super(data)

    const value = this.credential.eligibility_status
    switch (value) {
      case 'passed': {
        this.validityLabel = `Passed ${this.getDate(this.credential.effective_at)}`
        this.setStatusTag({ value })
        break
      }
      case 'failed': {
        this.setStatusTag({ value, color: 'red' })
        break
      }
      default: this.defaultStatusTag()
    }
  }

}
